import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from "../contexts/auth";
import {  getLendsURL } from '../utils/api';

const useGetLends = ({ 
        page = 1,
        limit = 3000,
        keyword, 
        toolId,
        mechanicId, 
        setErrors
    }) => {
        
    const { auth } = useAuth();
    const [ gettingLends, setGettingLends ] = useState(false);
    const [ lends, setLends ] = useState([]);
    const [ totalLends, setTotalLends ] = useState(0);
    const [ gettingLendsReqSuccess, setGettingLendsReqSuccess ] = useState(false);
    
    useEffect(() => {

        if (gettingLends) {
            axios.get(getLendsURL,
            {
                headers: {
                    Authorization: `Bearer ${auth.authToken}`
                },
                params: {
                    page,
                    limit,
                    keyword, 
                    toolId,
                    mechanicId, 
                }
            }).then(result => {
                setGettingLends(false);
                if (result.status === 200) {
                    const data = result.data.data;
                    if (result.data.total) {
                        setTotalLends(result.data.total);
                    }
                    setGettingLendsReqSuccess(true);
                    setLends(data);         
                } else {
                    // console.log(result.data.errors);
                    if (setErrors) {
                        setErrors(result.data.errors);
                    }
                    setGettingLendsReqSuccess(false);
                    // setOperatorAddErrors(result.data.errors);
                }
            }).catch(e => {
                if (e.response === undefined) {
                    // console.log(e);
                    if (setErrors) {
                        setErrors(['Could not connect to server']);
                    }
                    // setOperatorAddErrors(['Could not connect to server!'])
                } else {
                    // console.log(e.response.data.errors);
                    // setOperatorAddErrors(e.response.data.errors)
                    if (setErrors) {
                        setErrors([e.response.data.errors]);
                    }
                }
                setGettingLendsReqSuccess(false);
                setGettingLends(false);
            });
        }
    }, [gettingLends]);

    return { lends, totalLends, gettingLends, setGettingLends, gettingLendsReqSuccess };
}

export default useGetLends;